import { render, staticRenderFns } from "./lock-order.vue?vue&type=template&id=85204648&scoped=true&"
import script from "./lock-order.vue?vue&type=script&lang=js&"
export * from "./lock-order.vue?vue&type=script&lang=js&"
import style0 from "./lock-order.vue?vue&type=style&index=0&id=85204648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85204648",
  null
  
)

export default component.exports